import styled from 'styled-components';
import media from '../../../styles/Media.styled';

export const ButtonContainer = styled.button.attrs(
    ({ onClick, disabled, onMouseDown }) => ({
        onclick: onClick,
        disabled: disabled,
        onmousedown: onMouseDown,
    })
)`
    width: ${(props) => props.width};
    height: ${(props) => props.height};
    background-color: ${(props) => props.backgroundColor};
    border: ${(props) =>
        props.border
            ? props.mouseDown
                ? '2px solid lightblue'
                : props.border
            : props.mouseDown
            ? '2px solid lightblue'
            : 'none'};
    border: ${(props) =>
        props.disabled && (props.border ? props.border : 'none')};
    font-family: ${(props) =>
        props.fontFamily ? props.fontFamily : 'AvenirNextWorld Demi'};
    font-size: ${(props) => props.fontSize};
    color: ${(props) => props.color};
    border-radius: ${(props) =>
        props.borderRadius ? props.borderRadius : '19px'};
    margin: ${(props) => props.margin};
    margin-right: ${(props) => props.marginRight};
    padding: ${(props) => props.padding};
    justify-content: center;
    align-items: center;
    display: ${(props) => (props.show ? 'flex' : 'none')};
    outline-style: none;
    cursor: ${(props) => !props.disabled && 'pointer'};
    opacity: ${(props) => props.opacity};
    white-space: ${(props) => props.WhiteSpace};
    min-width: ${(props) => props.minWidth};
    ${media.mobileDevice`
        width: ${(props) => props.mobileWidth};
        height:${(props) => props.mobileHeight};
        margin: ${(props) => props.mobileMargin};
        margin-top: ${({ mobileMarginTop }) =>
            mobileMarginTop ? mobileMarginTop : ''};
        margin-bottom: ${({ mobileMarginBottom }) =>
            mobileMarginBottom ? mobileMarginBottom : ''};
        min-width: ${(props) => props.mobileMinWidth};
        border: ${(props) => props.mbBorder && props.mbBorder};
        font-size: ${(props) => props.fontSizeMobile};
    `};
    box-shadow: ${(props) => (props.boxShadow ? props.boxShadow : 'unset')};
    @media screen and (min-width: 768px) and (max-width: 768px) and (orientation: portrait) {
        /* For portrait layouts only */

        width: ${(props) => (props.ipadWidth ? props.ipadWidth : '')};
    }
    @media only screen and (min-width: 820px) and (max-width: 834px) and (orientation: portrait) {
        width: ${(props) => (props.ipadWidth ? props.ipadWidth : '')};
    }
    @media only screen and (min-device-width: 1180px) and (max-device-width: 1180px) and (orientation: landscape) {
        width: ${(props) => (props.ipadWidth ? props.ipadWidth : '')};
    }
        @media only screen and (min-device-width: 667px) and (max-device-width: 1023px) and (orientation : landscape) {
        width: ${({ landscapeWidth }) => landscapeWidth};
        height: ${({ landscapeHeight }) => landscapeHeight};
    }
`;
